import type { LessonWithProgress } from '../types';

/**
 * THE one definition of "the next lesson" (PR #1023 review). Three places
 * used to answer it separately: the store's findTargetLessonPath (which
 * chapter to open and where the phone filters start), the lesson card's
 * scroll anchor, and the Course page's orange "current" marker. With an
 * untried lesson before one in progress the marker and the scroll picked
 * different lessons. All three read these now.
 */

/** Started and not passed: it has a best attempt below the pass. */
export function isLessonInProgress(lesson: LessonWithProgress): boolean {
  return !!lesson.best_attempt && !lesson.passed;
}

/** Open, not passed, and never tried. */
export function isLessonUpNext(lesson: LessonWithProgress): boolean {
  return !lesson.locked && !lesson.passed && !!lesson.never_tried;
}

/** A list's next step: the first lesson in progress, else the first up next. */
export function nextLesson(lessons: LessonWithProgress[]): LessonWithProgress | null {
  return lessons.find(isLessonInProgress) ?? lessons.find(isLessonUpNext) ?? null;
}
